import React, { Component } from "react";
import { connect } from "react-redux";
import { generateCoctRobGraphObj } from "../../util-functions/util-funtions";
import Button from "@material-ui/core/Button";
import CategoryMiddleware from "../../store/middleware/categoryMiddleware";
import BrandsMiddleware from "../../store/middleware/brandsMiddleware";
import SkusMiddleware from "../../store/middleware/skusMiddleware";
import RegionsMiddleware from "../../store/middleware/regionMiddleware";
import DemandDriverMiddleware from "../../store/middleware/demandDriverMiddleware";
import DownloadPrimaryXlxMiddleware from "../../store/middleware/downloadPrimaryXlxMiddleware";
import PrimaryDashboardMiddleware from "../../store/middleware/primaryDashboardMiddleware";
import CoctRotMiddleware from "../../store/middleware/coctrobMiddleware";
import TrendLineChart from "../../components/line-charts/LineChart";
import MyBarChart from "../../components/bar-charts/MyBarChart";
import QuarterAnalysisBarChart from "../../components/bar-charts/QtrAnBarChart";
import CustomSelect from "../../components/common/select/Select";
import YOYTable from "../../components/tables/yoyTable";
import QuartersTable from "../../components/tables/quarterTable";
import HalfTable from "../../components/tables/halfTable";
import HalfGrowthTable from "../../components/tables/halfGrowthTable";
import TotalsTable from "../../components/tables/totalsTable";
import YOYBarChart from "../../components/bar-charts/YOYBarCharts";
import VerticalChart from "../../components/bar-charts/VerticalChart";
import MyPieChart from "../../components/pie-charts/pieChart";
import SeasonCoutTable from "../../components/tables/seasonCountTable";
import GrowthTable from "../../components/tables/growthTable";
import HalfCountTable from "../../components/tables/halfCountTable";
import GrowthTotalTable from "../../components/tables/growthTotalTable";
import DownloadIcon from "../../assets/images/downloadIcon.svg";
import Downloading from "../../assets/gifs/Downloading.gif";
import "../../assets/style/sfos.styles.scss";
import "./PrimaryDashboard.styles.scss";
import { Loader } from "../../components/loader";
import { compare } from '../../prat_screen/gt/validation/sort';
import CustomToast from '../../util-functions/customToast.jsx'

export class PrimaryDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      myTempSkus: [],
      myTempBrands: [],
      myBrands: [],
      mySkus: [],
      selectedValue: "",
      isLoading: false,
      category: [],
      selectedCategory: [],
      selectedBrand: [],
      selectedSku: [],
      selectedRegion: [],
      newSelectedBrand: [],
      isValue: false,
      selectedDemandDriver: {
        label: "Primary Sale",
        value: "57d0ddaf-6be9-43f9-87a2-76785ffccad6",
      },
      isLoadingInitial: true,
      DemandDriver: [
        {
          label: "Primary Sale",
          value: "57d0ddaf-6be9-43f9-87a2-76785ffccad6",
        },
        {
          label: "Cannibalization",
          value: "db163f27-4da0-4e11-8247-ced1c828fcd8",
        },
        {
          label: "AdvertisingImpact",
          value: "920d7625-b557-464e-a75d-ba44e33cd7e1",
        },
        {
          label: "CategoryPromotionCP",
          value: "ae9d355a-0410-4972-a9cb-6965d6aeb236",
        },
        {
          label: "CustomerPromotionTPR",
          value: "5226e144-9eb3-4da0-bcf6-bed2d5f1a8fd",
        },
        {
          label: "CustomerPromotionEDLP",
          value: "04893170-664a-47d5-81ce-e4ed6158bb20",
        },
        {
          label: "CustomerPromotionSBB",
          value: "717a11fc-cbba-46f5-8ad0-99a48db5fd21",
        },
        {
          label: "CustomerPromotionMT",
          value: "7ea61b96-d0c5-4856-8d8c-c73cbc635355",
        },
        {
          label: "CustomerPromotionAPGifts",
          value: "1bc870dc-d4dd-4c52-9f14-50d2869c44c3",
        },
        {
          label: "Others",
          value: "85539959-5448-49e6-9908-e6d00a0a122c",
        },
        {
          label: "HolidaysDIP",
          value: "71756d10-ae30-4ef4-940f-c0567401e5d8",
        },
        {
          label: "Pricing",
          value: "6601ba38-94e5-4354-9952-abdcb4da2fad",
        },
        {
          label: "Grammage",
          value: "ba8d49fe-9bae-4034-a81b-b9996b973a0f",
        },
        {
          label: "EndStockCorrection",
          value: "9bf3518e-329b-4b43-8049-1d0b06ef31e5",
        },
        {
          label: "Constraint",
          value: "b875e540-afd0-4bd1-8f09-fb066d61ec97",
        },
        {
          value: "d19ab530-af9b-4f21-81b9-6b71c8354d6e",
          label: "AgreedBaselineForecast",
        },
      ],
      primaryDashboard: "",
      volumeOptions: [
        {
          label: "VOLUME",
          value: false,
        },
        {
          label: "VALUE",
          value: true,
        },
      ],
      value: "",
      selectedMonthType: true,
      monthTypeOptions: [
        { label: 'JC', value: false },
        { label: 'GREG', value: true }
      ]
    };
  }

  componentDidMount() {
    if (!navigator.onLine) {
      // ToastsStore.error("You are Offline");
      CustomToast('error', 'You are Offline')
      return;
    }
    setTimeout(() => {
      this.props.getCategory();
      this.props.getDemandDriver();
      this.props.getBrands();
      this.props.getSkus();
      this.props.getRegions();
    }, 1000);
  }

  componentDidUpdate(prevProps, prevState) {

    if (prevProps.category !== this.props.category) {
      this.getDataOnComponentMount();
    }

    if (prevProps.brands !== this.props.brands) {
      this.getBrands();
    }

    if (prevProps.primaryDashboard !== this.props.primaryDashboard) {
      this.setState({
        isLoadingInitial: false
      })
    }

    if(this.props.primaryDashboardHasError){
      this.setState({
        isLoadingInitial: false
      })
    }
  }

  getDataOnComponentMount = () => {
    this.props.postPrimaryDashboard(
      [this.props.category[0].Code],
      this.state.selectedBrand,
      this.state.selectedSku,
      this.state.selectedRegion,
      this.state.selectedDemandDriver,
      this.state.isValue,
      this.state.selectedMonthType
    );
    this.props.postCoctRob(
      [this.props.category[0].Code],
      this.state.selectedBrand,
      this.state.selectedSku,
      this.state.selectedRegion,
      this.state.selectedDemandDriver,
      this.state.isValue
    );
    this.setState(
      {
        selectedCategory: [this.props.category[0].Code],
        selectedDemandDriver: {
          label: "Primary Sale",
          value: "57d0ddaf-6be9-43f9-87a2-76785ffccad6",
        },
        isValue: false,
        isLoadingInitial: true
      });
  };
  getBrands = () => {
    // setTimeout(() => {
    const { selectedCategory } = this.state;
    const { brands, category } = this.props;
    const productCategories = category?.filter(item => selectedCategory.includes(item.Code));
    let filteredbrands = [];
    try {

      if (productCategories.length) {
        for (let i = 0; i < productCategories.length; i++) {
          filteredbrands.push(
            ...brands.filter((item) => {
              return item.Category === productCategories[i].guid;
            })
          );
        }
      }
      this.setState({
        myBrands: filteredbrands,
      },
        () => {
          let selectBrands = [];
          this.state.myBrands.length &&
            this.state.myBrands.forEach(item => selectBrands.push(item.Code));
          this.setState({
            selectedBrand: selectBrands
          });
        });
      this.getSkus();

    } catch (error) {
      setTimeout(() => {
        this.getBrands()
      }, 5000);
    }
    // }, 5000);
  };
  getSkus = () => {
    setTimeout(() => {
      const { selectedBrand } = this.state;
      const { skus, brands } = this.props;
      const productBrands = brands?.filter(item => selectedBrand.includes(item.Code));
      let filteredSkus = [];
      if (productBrands.length && skus?.length) {
        for (let i = 0; i < productBrands.length; i++) {
          filteredSkus.push(
            ...skus.filter((item) => {
              return item.Brand === productBrands[i].guid;
            })
          );
        }
      }

      this.setState({
        mySkus: filteredSkus,
      });
    }, 1000);
  };

  handleFilteredSkus = () => {
    const { selectedBrand, selectedSku } = this.state;
    const { skus, brands } = this.props;
    const productBrands = brands?.filter(item => selectedBrand.includes(item.Code));
    let filteredSkus = [];
    if (productBrands.length) {
      for (let i = 0; i < productBrands.length; i++) {
        filteredSkus.push(
          ...skus.filter((item) => {
            return item.Brand === productBrands[i].guid;
          })
        );
      }

      let arr = [];
      if (selectedSku.length) {
        filteredSkus.forEach(item => {
          if (selectedSku.includes(item.Code)) {
            arr.push(item.Code)
          }
        })
        this.setState({ selectedSku: arr });
      }

      this.setState({
        mySkus: filteredSkus,
      });
    }
  };

  handleChange = (selectedValue) => {
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      this.setState({
        selectedCategory: [],
        myBrands: [],
        selectedBrand: [],
        selectedSku: [],
        mySkus: [],
      });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });

      this.setState({ selectedCategory: arr }, () => {
        this.getBrands();
      });
    }
  };

  handleBrandChange = (selectedValue) => {
    let arr = [];
    if (selectedValue === null || selectedValue.length === 0) {
      this.setState({ selectedBrand: [], selectedSku: [], mySkus: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedBrand: arr }, () => {
        this.handleFilteredSkus();
      });
    }
  };

  handleSkus = (selectedValue) => {
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedSku: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedSku: arr });
    }
  };
  handleRegion = (selectedValue) => {
    let arr = [];
    if (selectedValue === null) {
      this.setState({ selectedRegion: [] });
    } else {
      selectedValue.forEach((element) => {
        arr.push(element.value);
      });
      this.setState({ selectedRegion: arr });
    }
  };

  handleIsValue = (selectedValue) => {
    if (selectedValue) {
      this.setState({
        isValue: selectedValue.value,
      });
    }
  };

  handleDemandDriver = (selectedValue) => {
    let arr = [];
    arr.push(selectedValue.value);
    this.setState({ selectedDemandDriver: selectedValue });
  };

  handleSubmit = (e) => {
    const {
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedDemandDriver,
      isValue,
      selectedMonthType
    } = this.state;
    this.props.postPrimaryDashboard(
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedDemandDriver,
      isValue,
      selectedMonthType
    );
    this.props.postCoctRob(
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedDemandDriver,
      isValue
    );
  };

  handleDownload = (e) => {
    e.preventDefault();
    this.props.downloadXlx(this.props.primaryDashboard, this.props.coctrob);
  };

  handleMonthTypeOptions = (val) => {
    this.setState({
      selectedMonthType: val.value
    })
  }

  render() {
    const { category, regions, coctrob } = this.props;
    let coctrobData;
    if (this.props.isCotcRobErrorMessage) {
      coctrobData = [];
    } else {
      if (this.props.primaryDashboard?.TotalVolume.length > 0 && coctrob) {
        coctrobData = generateCoctRobGraphObj(
          this.props.primaryDashboard.TotalVolume,
          this.props.coctrob
        );
      }
    }
    return (
      <div className="page-container">
        {(this.props.isPrimaryDashboardLoading || this.props.isCoctRobLoading) ||
          this.state.isLoadingInitial ||
          (this.props.primaryDashboard === undefined || this.props.coctrob === undefined) ? (
          <Loader flag={true} />
        ) : (
          <>
            <div className="heading-and-download-container">
              <span className="component-heading">Primary Dashboard</span>

              {this.props.isFileDownloading ? (
                <img
                  src={Downloading}
                  style={{ width: "26px", height: "31px" }}
                  alt=''
                />
              ) : (
                <img
                  src={DownloadIcon}
                  onClick={this.handleDownload}
                  className="download-xlx-img"
                  alt="xldownload"
                />
              )}
            </div>

            {/* Filter section start */}
            <div className="select-container">
              <div className="filters-container-only">
                <CustomSelect.MyCustomSelect
                  placeholder={"Category"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    category
                      ? category.sort(compare).map((item) => {
                        return {
                          value: item.Code,
                          label: item.Name,
                        };
                      })
                      : []
                  }
                  onChange={this.handleChange}
                  value={
                    category
                      ? category
                        .filter((item) => {
                          return this.state.selectedCategory.includes(
                            item.Code
                          );
                        })
                        .map((item) => {
                          return {
                            value: item.Code,
                            label: item.Name,
                          };
                        })
                      : []
                  }
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Brands"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    this.state.myBrands.length !== 0
                      ? this.state.myBrands.sort(compare).map((item) => ({
                        value: item.Code,
                        label: item.Name,
                      }))
                      : []
                  }
                  onChange={this.handleBrandChange}
                  value={this.state.myBrands
                    .filter((item) => {
                      return this.state.selectedBrand.includes(item.Code);
                    })
                    .map((item) => {
                      return {
                        value: item.Code,
                        label: item.Name,
                      };
                    })}
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"MSKUs"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    this.state.mySkus.length !== 0
                      ? this.state.mySkus.sort(compare).map((item) => ({
                        value: item.Code,
                        label: item.Description,
                      }))
                      : []
                  }
                  onChange={this.handleSkus}
                  value={this.state.mySkus
                    .filter((item) => {
                      return this.state.selectedSku.includes(item.Code);
                    })
                    .map((item) => {
                      return {
                        value: item.Code,
                        label: item.Description,
                      };
                    })}
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Region"}
                  allowSelectAll={true}
                  isMulti
                  options={
                    regions
                      ? regions.sort(compare).map((item) => ({
                        value: item.guid,
                        label: item.Name.toUpperCase(),
                      }))
                      : []
                  }
                  onChange={this.handleRegion}
                  value={
                    regions
                      ? regions
                        .filter((item) => {
                          return this.state.selectedRegion.includes(
                            item.guid
                          );
                        })
                        .map((item) => {
                          return {
                            value: item.guid,
                            label: item.Name.toUpperCase(),
                          };
                        })
                      : null
                  }
                />

                <CustomSelect.MySelect
                  options={this.state.volumeOptions}
                  onChange={this.handleIsValue}
                  defaultValue={
                    this.state.isValue
                      ? this.state.volumeOptions[1]
                      : this.state.volumeOptions[0]
                  }
                />

                <CustomSelect.MyCustomSelect
                  placeholder={"Demand Driver"}
                  className="single-list-select"
                  options={this.state.DemandDriver}
                  onChange={this.handleDemandDriver}
                  value={this.state.selectedDemandDriver}
                />

                <CustomSelect.MySelect
                  options={this.state.monthTypeOptions}
                  onChange={this.handleMonthTypeOptions}
                  value={
                    !this.state.selectedMonthType ?
                      this.state.monthTypeOptions[0] :
                      this.state.monthTypeOptions[1]
                  }
                />

              </div>

              <Button
                style={{ marginBottom: 10 }}
                variant="outlined"
                className="submit-btn"
                onClick={(e) => this.handleSubmit(e)}
              >
                SUBMIT
              </Button>

            </div>
            {/* Filter section end */}

            {/* Four table group for YOY-Volume */}
            <div className="main-table-container">
              <span className="table-container-heading">YOY - Volume</span>
              <div className="four-tables">
                <YOYTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.Volume
                      : []
                  }
                />
                <QuartersTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.QuaterVolume
                      : null
                  }
                />
                <HalfTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.HalfVolume
                      : null
                  }
                />
                <TotalsTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.TotalVolume
                      : null
                  }
                />
              </div>
            </div>

            {/* Four table group for YOY-AWS */}
            <div className="main-table-container">
              <span className="table-container-heading">YOY - AWS</span>
              <div className="four-tables">
                <YOYTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.Aws
                      : []
                  }
                />
                <QuartersTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.QuaterAws
                      : null
                  }
                />
                <HalfTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.HalfAws
                      : null
                  }
                />
                <TotalsTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.TotalAws
                      : null
                  }
                />
              </div>
            </div>

            {/* Four table group for YOY-ADS */}
            <div className="main-table-container">
              <span className="table-container-heading">YOY - ADS</span>
              <div className="four-tables">
                <YOYTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.Ads
                      : []
                  }
                />
                <QuartersTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.QuaterAds
                      : null
                  }
                />
                <HalfTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.HalfAds
                      : null
                  }
                />
                <TotalsTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.TotalAds
                      : null
                  }
                />
              </div>
            </div>

            {/* Trend Line &&  Quarter Analysis && H1 vs H2 graphs */}
            <div className="main-chart-container">
              <div className="chart-div">
                <div className="chart-title-container">
                  <span className="chart-title">Trend Line</span>
                </div>
                <TrendLineChart
                  data={
                    this.props.primaryDashboard &&
                      this.props.primaryDashboard.Volume.length > 0
                      ? this.props.primaryDashboard.Volume
                      : []
                  }
                />
              </div>

              <div className="chart-div">
                <div className="chart-title-container">
                  <span className="chart-title">Quarter Analysis</span>
                </div>

                <MyBarChart
                  dataKey="QuaterVolume"
                  data={
                    this.props.primaryDashboard &&
                      this.props.primaryDashboard.QuaterVolume.length > 0
                      ? this.props.primaryDashboard.QuaterVolume
                      : []
                  }
                />
              </div>

              <div className="chart-div">
                <div className="chart-title-container">
                  <span className="chart-title">H1 vs H2</span>
                </div>

                <QuarterAnalysisBarChart
                  dataKey="HalfVolume"
                  data={
                    this.props.primaryDashboard?.HalfVolume.length > 0
                      ? this.props.primaryDashboard.HalfVolume
                      : []
                  }
                />
              </div>
            </div>

            {/* charts with widgets */}
            <div className="main-chart-table-container">
              <div className="chart-table-div-1">
                <div className="chart-title-container">
                  <span className="chart-title">YOY</span>
                </div>
                <YOYBarChart
                  data={
                    this.props.primaryDashboard?.TotalVolume.length > 0
                      ? this.props.primaryDashboard.TotalVolume
                      : []
                  }
                />
              </div>

              <div className="piechart-PD-container">
                <div className="chart-title-container-COCTROB">
                  <span className="chart-title">
                    COTC vs ROB - Vol & Growth
                  </span>
                </div>
                <div className="PD-VerticalChart">
                  <VerticalChart data={this.props.coctrob ? coctrobData : []} />

                  <div style={{ flexGrow: "1" }}></div>

                  <div className="pie-PD-container">
                    {this.props.coctrob ? (
                      <div className="sub-piechart-container">
                        <span className="percentage-value">
                          {this.props.coctrob && coctrobData
                            ? coctrobData[1].contribution + "%"
                            : []}
                        </span>
                        <MyPieChart
                          type="PD"
                          data={
                            this.props.coctrob && coctrobData
                              ? coctrobData[1]
                              : []
                          }
                          colorFill="#0353a4"
                          colorVoid="#C4D7EA"
                        />
                        <span className="pie-heading">
                          {this.props.coctrob && coctrobData
                            ? coctrobData[1].name
                            : []}
                        </span>
                      </div>
                    ) : null}
                    {this.props.coctrob ? (
                      <div className="sub-piechart-container">
                        <span className="percentage-value">
                          {this.props.coctrob && coctrobData
                            ? coctrobData[0].contribution + "%"
                            : []}
                        </span>
                        <MyPieChart
                          type="PD"
                          data={
                            this.props.coctrob && coctrobData
                              ? coctrobData[0]
                              : []
                          }
                          colorFill="#fca311"
                          colorVoid="#FFEAC8"
                        />
                        <span className="pie-heading">
                          {this.props.coctrob && coctrobData
                            ? coctrobData[0].name
                            : []}
                        </span>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>

              <div className="chart-table-div-2">
                <div className="chart-title-container">
                  <span className="chart-title">H1 vs H2 Growth</span>
                </div>
                <HalfGrowthTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.GrowthHalf
                      : null
                  }
                />
              </div>

              <div className="chart-table-div-3">
                <div
                  className="widget-container"
                  style={{ marginBottom: "8px" }}
                >
                  <span className="widget-heading">VG for Year {new Date().getFullYear()}</span>
                  <span className="widget-value">
                    {this.props.primaryDashboard
                      ? this.props.primaryDashboard.VG
                      : "--"}
                    %
                  </span>
                </div>
                <div className="widget-container">
                  <span className="widget-heading" style={{ display: 'flex', flexDirection: 'column', textAlign: 'left' }}>
                    CAGR 5 Years
                    <span style={{ fontSize: '12px' }}>({new Date().getFullYear() - 4}-{new Date().getFullYear()})</span>
                  </span>
                  <span className="widget-value">
                    {this.props.primaryDashboard
                      ? this.props.primaryDashboard.CAGR
                      : "--"}
                    %
                  </span>
                </div>
              </div>
            </div>

            {/* last row of tables */}
            <div className="last-table-row">
              <div className="seasonality-table-container">
                <div className="chart-title-container">
                  <span className="chart-title">Seasonality</span>
                </div>

                <SeasonCoutTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.Seasonality
                      : null
                  }
                />
              </div>

              <div className="seasonality-table-container">
                <div className="chart-title-container">
                  <span className="chart-title">Contribution</span>
                </div>

                <SeasonCoutTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.Contribution
                      : null
                  }
                />
              </div>

              <div className="seasonality-table-container">
                <div className="chart-title-container">
                  <span className="chart-title">Quarterly Growth</span>
                </div>

                <GrowthTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.GrowthQuater
                      : null
                  }
                />
              </div>

              <div className="half-cont-table-container">
                <div className="chart-title-container">
                  <span className="chart-title">Half-Yr Contribution</span>
                </div>

                <HalfCountTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.HalfContribution
                      : null
                  }
                />
              </div>

              <div className="total-growth-table-container">
                <div className="chart-title-container">
                  <span className="chart-title">Growth</span>
                </div>

                <GrowthTotalTable
                  data={
                    this.props.primaryDashboard
                      ? this.props.primaryDashboard.GrowthTotal
                      : null
                  }
                />
              </div>
            </div>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.CategoryReducer.isLoading,
    category: state.CategoryReducer.category,
    isCategoryLoading: state.CategoryReducer.isCategoryLoading,
    brands: state.BrandsReducer.brands,
    skus: state.SkusReducer.skus,
    regions: state.RegionReducer.regions,
    demandDriver: state.DemandDriverReducer.demandDriver,
    primaryDashboard: state.PrimaryDashboardReducer.primaryDashboard,
    isPrimaryDashboardLoading:
      state.PrimaryDashboardReducer.isPrimaryDashboardLoading,
    primaryDashboardHasError: state.PrimaryDashboardReducer.primaryDashboardHasError,
    coctrob: state.CoctRobReducer.coctrob,
    isCoctRobLoading: state.CoctRobReducer.isCoctRobLoading,
    errorMessage: state.PrimaryDashboardReducer.errorMessage,
    isCotcRobErrorMessage: state.CoctRobReducer.errorMessage,
    isFileDownloading: state.DownloadXlxReducer.isFileDownloading,
  };
};

const mapDispatchToprops = (dispatch) => {
  return {
    getCategory: () => {
      return dispatch(CategoryMiddleware.getCategory());
    },
    getBrands: () => {
      return dispatch(BrandsMiddleware.getBrands());
    },
    getSkus: () => {
      return dispatch(SkusMiddleware.getSkus());
    },
    getRegions: () => {
      return dispatch(RegionsMiddleware.getRegions());
    },
    getDemandDriver: () => {
      return dispatch(DemandDriverMiddleware.getDemandDriver());
    },
    postPrimaryDashboard: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedDemandDriver,
      isValue,
      selectedMonthType
    ) => {
      return dispatch(
        PrimaryDashboardMiddleware.postPrimaryDashboard(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectedDemandDriver,
          isValue,
          selectedMonthType
        )
      );
    },
    postCoctRob: (
      selectedCategory,
      selectedBrand,
      selectedSku,
      selectedRegion,
      selectedDemandDriver,
      isValue
    ) => {
      return dispatch(
        CoctRotMiddleware.postCoctRob(
          selectedCategory,
          selectedBrand,
          selectedSku,
          selectedRegion,
          selectedDemandDriver,
          isValue
        )
      );
    },
    downloadXlx: (primaryDashboard, coctrob) => {
      return dispatch(
        DownloadPrimaryXlxMiddleware.downloadXlx(primaryDashboard, coctrob)
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToprops)(PrimaryDashboard);
